var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { Focusable } from "@/common/mixins/Focusable";
import { Savable } from '@/common/mixins/Savable';
import { ExpandedOperation } from '@/common/types/ExpandedOperation';
import { AidTypeSpecification } from '@/common/types/AidTypeSpecification';
import PlaceOpenOperationView from '@/template/components/expandedSBE/placeOpen/OperationView.vue';
import Estimates, { createEmptyEstimateItem } from '@/common/types/Estimates';
import { EstimateType } from '@/common/types/EstimateType';
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import RadioButtonRow from '@/common/components/RadioButtonRow.vue';
import CheckBoxListRow from '@/common/components/CheckBoxListRow.vue';
import EstimatesControl from '@/template/components/aidApplication/budgetaryEstimate/EstimatesControl.vue';
import TargetControl from '@/template/components/aidApplication/operation/TargetControl.vue';
var ExpandedOperationView = /** @class */ (function (_super) {
    __extends(ExpandedOperationView, _super);
    function ExpandedOperationView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.checkBoxValuesChanged = "";
        return _this;
    }
    Object.defineProperty(ExpandedOperationView.prototype, "isAy", {
        get: function () {
            return this.specification.isAy;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExpandedOperationView.prototype, "isPlaceOpen", {
        get: function () {
            return this.specification.isPlaceOpen;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExpandedOperationView.prototype, "isExtension", {
        get: function () {
            return this.specification.isExtensionApplication;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExpandedOperationView.prototype, "applicationYear", {
        get: function () {
            var record = this.$store.getters["vuexPageModule/record"];
            return record.year;
        },
        enumerable: false,
        configurable: true
    });
    ExpandedOperationView.prototype.mounted = function () {
        this.focusOnFirstTag("h1");
    };
    Object.defineProperty(ExpandedOperationView.prototype, "information", {
        get: function () {
            return this.operation.information;
        },
        set: function (information) {
            this.information = information;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExpandedOperationView.prototype, "showSimilarities", {
        get: function () {
            return !this.isAy;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExpandedOperationView.prototype, "showNonProfitDescription", {
        get: function () {
            return this.showSimilarities && this.information.similaritiesToOtherOperations.nonProfit;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExpandedOperationView.prototype, "showCommercialActivityDescription", {
        get: function () {
            return this.showSimilarities && this.information.similaritiesToOtherOperations.commercialActivity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExpandedOperationView.prototype, "showPublicSectorDescription", {
        get: function () {
            return this.showSimilarities && this.information.similaritiesToOtherOperations.publicSector;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExpandedOperationView.prototype, "targetGroupEstimates", {
        get: function () {
            if (this.operation.yearlyTargetGroupTotals.length == 0) {
                this.operation.yearlyTargetGroupTotals.push(this.createTargetGroupEstimate());
            }
            return new Estimates(this.operation.yearlyTargetGroupTotals);
        },
        enumerable: false,
        configurable: true
    });
    ExpandedOperationView.prototype.createTargetGroupEstimate = function () {
        var item = createEmptyEstimateItem(this.applicationYear);
        item.type = EstimateType.Operation_TargetGroup;
        return item;
    };
    ExpandedOperationView.prototype.onNonProfitChanged = function () {
        if (this.information.similaritiesToOtherOperations.nonProfit == false && this.information.nonProfitDescription) {
            if (confirm(this.$i18n.t("AidApplication.Confirm.Delete.Similarities.NonProfit").toString())) {
                if (!this.showNonProfitDescription)
                    this.information.nonProfitDescription = null;
            }
            else {
                this.information.similaritiesToOtherOperations.nonProfit = true;
                this.checkBoxValuesChanged = Date();
            }
        }
    };
    ExpandedOperationView.prototype.onCommercialActivityChanged = function () {
        if (this.information.similaritiesToOtherOperations.commercialActivity == false && this.information.commercialActivityDescription) {
            if (confirm(this.$i18n.t("AidApplication.Confirm.Delete.Similarities.CommercialActivity").toString())) {
                if (!this.showCommercialActivityDescription)
                    this.information.commercialActivityDescription = null;
            }
            else {
                this.information.similaritiesToOtherOperations.commercialActivity = true;
                this.checkBoxValuesChanged = Date();
            }
        }
    };
    ExpandedOperationView.prototype.onPublicSectorChanged = function () {
        if (this.information.similaritiesToOtherOperations.publicSector == false && this.information.publicSectorDescription) {
            if (confirm(this.$i18n.t("AidApplication.Confirm.Delete.Similarities.PublicSector").toString())) {
                if (!this.showPublicSectorDescription)
                    this.information.publicSectorDescription = null;
            }
            else {
                this.information.similaritiesToOtherOperations.publicSector = true;
                this.checkBoxValuesChanged = Date();
            }
        }
    };
    var _a, _b;
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_a = typeof ExpandedOperation !== "undefined" && ExpandedOperation) === "function" ? _a : Object)
    ], ExpandedOperationView.prototype, "operation", void 0);
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_b = typeof AidTypeSpecification !== "undefined" && AidTypeSpecification) === "function" ? _b : Object)
    ], ExpandedOperationView.prototype, "specification", void 0);
    __decorate([
        Watch("operation.information.similaritiesToOtherOperations.nonProfit"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ExpandedOperationView.prototype, "onNonProfitChanged", null);
    __decorate([
        Watch("operation.information.similaritiesToOtherOperations.commercialActivity"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ExpandedOperationView.prototype, "onCommercialActivityChanged", null);
    __decorate([
        Watch("operation.information.similaritiesToOtherOperations.publicSector"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ExpandedOperationView.prototype, "onPublicSectorChanged", null);
    ExpandedOperationView = __decorate([
        Component({
            name: "ExpandedOperationView",
            components: {
                TextAreaRow: TextAreaRow,
                RadioButtonRow: RadioButtonRow,
                CheckBoxListRow: CheckBoxListRow,
                EstimatesControl: EstimatesControl,
                TargetControl: TargetControl,
                PlaceOpenOperationView: PlaceOpenOperationView
            }
        })
    ], ExpandedOperationView);
    return ExpandedOperationView;
}(Mixins(Focusable, Savable)));
export default ExpandedOperationView;
